export { default } from './AlcoholWarning';
